import { useCallback, useMemo } from 'react';

export default function useStepperContextValue({
  isAdmin,
  practice,
  instance,
  stepsState,
  activeSubstep,
  orchestratorData,
  componentStepConfig,
  restrictedStepsCodes,
  goNext,
  goPrev,
  canGoPrev,
  navigateToSubstep,
  activateStepWithHiddenCheck,
  setHeaderButtonProps,
  setHeaderInfoTooltip,
  setHeaderOptionsOverride,
  setFooterConfig,
  addFooterActions
}) {
  const handleNavigateToSubstep = useCallback(
    (substepCode) => {
      if (restrictedStepsCodes.has(substepCode)) return;
      navigateToSubstep(substepCode);
    },
    [navigateToSubstep, restrictedStepsCodes]
  );

  const handleActivateStep = useCallback(
    (stepCode) => {
      if (restrictedStepsCodes.has(stepCode)) return;
      activateStepWithHiddenCheck(stepCode);
    },
    [activateStepWithHiddenCheck, restrictedStepsCodes]
  );

  const stepperContextValue = useMemo(
    () => ({
      isAdmin,
      practice,
      practiceId: practice?.id,
      wizardState: { instance, steps: stepsState },
      activeSubstep,
      orchestratorData,
      componentStepConfig,
      restrictedStepsCodes,
      goNext,
      goPrev,
      canGoPrev,
      navigateToSubstep: handleNavigateToSubstep,
      setHeaderButtonProps,
      setHeaderInfoTooltip,
      setHeaderOptionsOverride,
      setFooterConfig,
      addFooterActions
    }),
    [
      isAdmin,
      practice,
      instance,
      stepsState,
      activeSubstep,
      orchestratorData,
      componentStepConfig,
      restrictedStepsCodes,
      goNext,
      goPrev,
      canGoPrev,
      handleNavigateToSubstep,
      setHeaderButtonProps,
      setHeaderInfoTooltip,
      setHeaderOptionsOverride,
      setFooterConfig,
      addFooterActions
    ]
  );

  return { stepperContextValue, handleNavigateToSubstep, handleActivateStep };
}
